export const related = [
  '/puzzles/urban-fresh-code',
  '/puzzles/pulse-fitness',
  '/puzzles',
];
export const quickAnswer =
  'Columns 1–3: turn every interactable machine ON. Columns 4–5: all OFF. Column 6: only the machine nearest the door ON.';
export const sourceIds = ['powerpyx-hideouts'];
export const diagram = {
  src: '/diagrams/laundromat-pattern.svg',
  alt: 'Six columns: all available machines on in columns 1–3; columns 4–5 off; nearest-door machine on in column 6.',
  width: 1000,
  height: 360,
};

## Where to Find Wear'Em & Wash'Em

Look for the laundromat in Central. If its entrance has a red barrier, follow the red connections to the objects holding it in place.

## Correct Washing Machine Pattern

Face the machines and count columns from left to right. This puzzle checks the final states, rather than a timed sequence.

1. Column 1: switch on the available machine.
2. Columns 2 and 3: switch on both interactable machines in each column.
3. Columns 4 and 5: leave everything off.
4. Column 6: switch on the machine nearest the door; leave the other two off.

## Laundromat Puzzle Not Working?

Check column 4 carefully: a machine may already be running when you arrive. In column 6, use the door as your reference point rather than assuming the top machine is the correct one.

## What the Secret Hideout Gives You

The completed pattern opens the concealed room. Collect its health-upgrade item before leaving.
